import { saveImage, type ImageSaveDestination } from './saveImage';

export type PngSaveDestination = ImageSaveDestination;

/** Browser download links are ignored by WKWebView; the iOS shell writes to Photos. */
export async function savePng(blob: Blob, filename: string): Promise<PngSaveDestination> {
  if (blob.type !== 'image/png') throw new Error('This image must be a PNG to save.');
  return saveImage(blob, filename);
}

export function pngSaveMessage(destination: PngSaveDestination): string {
  return destination === 'photos' ? 'Saved to Photos.' :
    destination === 'share_sheet' ? 'Share sheet closed. Check Photos or Files if you chose a save action.' :
    'PNG download started.';
}
